export default __webpack_public_path__ + "static/media/diable_menu_icon.a6e318d2.svg";